import React, { useState } from 'react'
import { Button, DialogActions, DialogContent, DialogTitle, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { DialogProps } from "../../Dialogs/DialogProps";
import {hasValue} from "@amsanalytics/react-shared-library";
import {Organization} from "@amsanalytics/react-shared-library/build/Models/Organization";

export interface ICopyAppDialogResult{
  organizationId: string;
}

interface CopyAppDialogProps extends DialogProps<null> {
  applicationNumber: number;
  applicationId: string;
  organizations: Organization[];
  onConfirm(result: ICopyAppDialogResult): void;
}

export const CopyAppDialog = (props: CopyAppDialogProps) => {
  const [dialogResult, setDialogResult] = useState<ICopyAppDialogResult>(
    { organizationId: '' }
  );
  
  return (
    <>
      <DialogTitle id="form-dialog-title">Copy Application</DialogTitle>
      <DialogContent>
        <p style={{ fontSize: '16px', marginTop: 0, marginBottom: '1em', maxWidth: '500px' }}>
          You are copying application <b>{props.applicationNumber}</b>. Select location for the new application.
        </p>
        <InputLabel id="select-archive-customer-label">Location for copied application</InputLabel>
        <Select
          name="selectArchiveLocation"
          fullWidth
          labelId="select-archive-customer-label"
          id="select"
          value={dialogResult.organizationId}
          onChange={(event: SelectChangeEvent<string>, child: React.ReactNode) => {
            setDialogResult({
              ...dialogResult,
              organizationId: event.target.value as string || ''
            })
          }}
        >
          <MenuItem value="" disabled>Select an applicant...</MenuItem>
          {props.organizations.map((organization: Organization, key: number) => (
            <MenuItem key={key} value={organization.id}>{organization.name}</MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.closeDialog}
          variant='outlined'
          color="inherit"
          style={{ marginRight: '5px' }}>
          Cancel
        </Button>
        <Button
          onClick={() => props.onConfirm(dialogResult)}
          disabled={!hasValue(dialogResult.organizationId) || !hasValue(props.applicationId)}
          color="primary"
          variant='contained'>
          Copy Application
        </Button>
      </DialogActions>
    </>
  )
}